import { spawn, call } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import categorySagaWrapper from "./category/categorySaga";
import keHoachSagaWrapper from "./ke-hoach/keHoachSagaWrapper";
import chuongTrinhDaoTaoSagaWrapper from "./ctdt/chuongTrinhDaoTaoSagaWrapper";
import lopTinChiSagaWrapper from "./lop-tin-chi/lopTinChiSagaWrapper";
import tkbSaga from "./tkb/tkbSaga";
import { dangKyHoSaga } from "./dang-ky-ho/dangKyHoSaga";
import toChucThiSagaWrapper from "./tct/_toChucThiSagaWrapper";
import { tietThiSaga } from "./tct/tietThiSaga";
import tongHopSagaWrapper from "./tong-hop/tongHopSagaWrapper";
import { keHoachHocLaiSaga } from "./ke-hoach-hoc-lai/keHoachHocLaiSaga";
import quanLyDangKySagaWrapper from "./quan-ly-dang-ky/quanLyDangKySagaWrapper";
import { dangKyChuyenNganhSaga } from "./dang-ky-chuyen-nganh/dangKyChuyenNganhSaga";
import { phanLopChuyenNganhSaga } from "./phan-lop-chuyen-nganh/phanLopChuyenNganhSaga";


function* safeSaga(saga: () => Generator): any {
  try {
    yield call(saga);
  } catch (e) {
    yield call(safeSaga, saga);
  }
}

export default function* rootSaga() {
  const sagas = [
    authSaga,
    categorySagaWrapper,
    keHoachSagaWrapper,
    chuongTrinhDaoTaoSagaWrapper,
    lopTinChiSagaWrapper,
    tkbSaga,
    dangKyHoSaga,
    toChucThiSagaWrapper,
    tietThiSaga,
    tongHopSagaWrapper,
    keHoachHocLaiSaga,
    quanLyDangKySagaWrapper,
    dangKyChuyenNganhSaga,
    phanLopChuyenNganhSaga,
  ];

  for (const saga of sagas) {
    yield spawn(safeSaga, saga);
  }
}
